import React from "react";

export const Image7 = ({ title7, largeImage7, smallImage7 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage7} title7={title7} data-lightbox-gallery="gallery7">
          <div className="hover-text">
            <h4>{title7}</h4>
          </div>
          <img src={smallImage7} className="img-responsive" alt={title7} />{" "}
        </a>{" "}
        
      </div>
    </div>
    
  );
};
